module.exports = __webpack_public_path__ + "static/media/Activity_YOGA.ef5c3c07.png";